import React from 'react';
import './styles.css';

const Services = ({ services }) => {
  if (services && !!services.length)
    return (
      <div className="Listview__Card__services">{services.join(', ')}</div>
    );
  return '';
};
export default Services;
